export default function PageHeader({ eyebrow, title, description }) {
  return (
    <section className="pt-32 md:pt-40 pb-16 md:pb-24 bg-[#F5F5F3] border-b border-neutral-200">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {eyebrow && (
          <div className="overline mb-6" data-testid="page-header-eyebrow">
            / {eyebrow}
          </div>
        )}
        <h1
          className="hero-title text-5xl sm:text-6xl md:text-7xl lg:text-8xl max-w-5xl"
          data-testid="page-header-title"
        >
          {title}
        </h1>
        {description && (
          <p
            className="mt-8 text-lg md:text-xl text-neutral-600 max-w-2xl leading-relaxed"
            data-testid="page-header-description"
          >
            {description}
          </p>
        )}
      </div>
    </section>
  );
}
